import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { FaEllipsisV } from 'react-icons/fa';
import AdminAppBody from '../../../../components/admin/AdminAppBody';
import useApiCallHooks from '../../../../hooks/useApiCallHooks';
import { toast } from 'react-toastify';

const MentorStudentGroupList = () => {
  const [groups, setGroups] = useState([]);
  const [response, loading, error, callAPI] = useApiCallHooks();

  useEffect(() => {
    callAPI('get', 'mentor/group-list',"");
  }, []);

  useEffect(() => {
    if (response?.data) {
      setGroups(response.data);
    }
 
  }, [response, error]);

  return (
    <AdminAppBody
    loading={loading}
      content={
        <div className="container card mt-4 p-4">
          <div className="d-flex justify-content-between align-items-center mb-3">
            <div>
              <h4>Intern's Groups</h4>
              <p className="text-muted mb-0">
                Create and manage groups of students for collaborative learning.
              </p>
            </div>
            <Link to="/mentor/groups-add">
              <button className="btn btn-primary">+ Create Group</button>
            </Link>
          </div>
          <hr />

          <table className="table table-hover">
            <thead className="table-primary">
              <tr>
                <th>Sr No</th>
                <th>Group Name</th>
                <th>Type</th>
                <th>Program</th>
                <th>Total Members</th>
                <th>Action</th>
              </tr>
            </thead>
            <tbody>
              {groups.length === 0 ? (
                <tr>
                  <td colSpan="6" className="text-center">
                    No groups found.
                  </td>
                </tr>
              ) : (
                groups.map((group, index) => (
                  <tr key={group.id}>
                    <td>{index + 1}</td>
                    <td className="d-flex align-items-center gap-2">
                      <div
                        className="rounded-circle bg-primary text-white d-flex justify-content-center align-items-center"
                        style={{ width: '40px', height: '40px', fontWeight: 'bold' }}
                      >
                        {group.name ? group.name[0].toUpperCase() : 'G'}
                      </div>
                      <span>{group.name}</span>
                    </td>
                    <td>{group.type || '-'}</td>
                    <td>{group.program?.name || '-'}</td>
                    <td>{Array.isArray(group.student_ids) ? group.student_ids.length : 0}</td>
                    <td className="text-center">
                      <div className="dropdown">
                        <button
                          className="btn p-0 border-0 bg-transparent shadow-none text-dark"
                          type="button"
                          data-bs-toggle="dropdown"
                          aria-expanded="false"
                        >
                          <FaEllipsisV />
                        </button>
                        <ul className="dropdown-menu dropdown-menu-end mt-2">
                     <li>
  <Link to={"/mentor/student-list/"+ group.slug} className="dropdown-item">
    View Members
  </Link>
</li>
{/* 
                          <li>
                            <button className="dropdown-item">View Tasks</button>
                          </li>
                          <li>
                            <button className="dropdown-item">Assign Task</button>
                          </li>
                          <li>
                            <button className="dropdown-item">Schedule Sessions</button>
                          </li> */}
                        </ul>
                      </div>
                    </td>
                  </tr>
                ))
              )}
            </tbody>
          </table>
        </div>
      }
    />
  );
};

export default MentorStudentGroupList;
